import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Angèle Rosalie - Sage-femme libérale à Annecy | Accouchement physiologique plateau technique",
  description = "Sage-femme libérale à Annecy. Accouchement physiologique en plateau technique (CH Annecy Genevois), suivi de grossesse, préparation à la naissance orientée physiologique, allaitement, sensibilisation perturbateurs endocriniens, surveillance de l'ictère. Prise en charge Grand Annecy.",
  keywords = "sage-femme Annecy, accouchement physiologique, plateau technique, grossesse Annecy, préparation naissance, allaitement, perturbateurs endocriniens, post-partum, ictère, Grand Annecy, Centre Hospitalier Annecy Genevois",
  ogTitle = "Angèle Rosalie - Sage-femme libérale à Annecy | Accouchement physiologique",
  ogDescription = "Accouchement physiologique en plateau technique à l'hôpital d'Annecy. Suivi de grossesse, préparation, post-partum, allaitement. Prise en charge Grand Annecy.",
  ogUrl = "https://xn--angle-accouchementphysio-annecy-gzc.com/",
  ogImage = "https://xn--angle-accouchementphysio-annecy-gzc.com/og-image.jpg",
  twitterTitle = "Angèle Rosalie - Sage-femme libérale à Annecy",
  twitterDescription = "Accouchement physiologique en plateau technique à l'hôpital d'Annecy. Suivi de grossesse, préparation, post-partum, allaitement.",
  twitterImage = "https://xn--angle-accouchementphysio-annecy-gzc.com/og-image.jpg"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Angèle Rosalie" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={ogUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content="Angèle Rosalie - Sage-femme libérale" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={twitterTitle} />
      <meta name="twitter:description" content={twitterDescription} />
      <meta name="twitter:image" content={twitterImage} />

      {/* Additional SEO */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      
      {/* Language and Location */}
      <meta httpEquiv="content-language" content="fr-FR" />
      <meta name="language" content="French" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Mobile Optimization */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Angèle Rosalie" />
    </Helmet>
  );
};

export default SEO;